import React from 'react';
import { all, takeEvery, takeLeading, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { getTenantId, Toast, toastMessage } from '../../utils/helper';
import {
    GET_CANDIDATE,
    POST_CANDIDATE,
    CANCEL_INTERVIEW,
    POST_BULK_CANDIDATE,
    GET_DROPDOWN_QUESTION,
    GET_DROPDOWN_POSITION,
    RESEND_EMAIL,
    COMPARE_JD_CV,
    RESUME_INTERVIEW,
    MANUAL_INVITE,
    FETCH_RESUME_SCORE,
    MANUAL_CALL_END,
    ADD_CANDIDATE_BANK,
    GET_CANDIDATE_BANK,
    EDIT_CANDIDATE_BANK,
    DELETE_CANDIDATE_BANK,
    GET_CANDIDATE_BANK_LIST,
    DELETE_CANDIDATE_BANK_LIST,
    ADD_EDIT_CANDIDATE_BANK_LIST,
    GET_CANDIDATE_BANK_DROPDOWN_LIST,
    CHECK_CANDIDATE_BANK_EXISTS,
    PUT_FINAL_OUTCOME,
    CREATE_CANDIDATES,
    GET_INTERVIEW_INC_SCREEN,
    GET_CANDIDATE_GLOBAL_FIELDS,
    GET_CANDIDATE_STATUS_FILTERS,
    GET_INTERVIEW_DETAILS_BY_ID_EMPLOYEE,
    REINVITE_UNATTENDED,
} from '../action/types';
import {
    getCandidateSuccess,
    getCandidateFailure,
    createOrUpdateCandidateSuccess,
    createOrUpdateCandidateFailure,
    cancelInterviewSuccess,
    cancelInterviewFailure,
    getDropdownQuestionSuccess,
    getDropdownQuestionFailure,
    getDropdownPositionSuccess,
    getDropdownPositionFailure,
    resendEmailSuccess,
    resendEmailFailure,
    compareJDCVSuccess,
    compareJDCVFailure,
    resumeInterviewSuccess,
    resumeInterviewFailure,
    manualInviteSuccess,
    manualInviteFailure,
    fetchResumeScoreSuccess,
    fetchResumeScoreFailure,
    manualCallEndSuccess,
    addCandidateBankSuccess,
    addCandidateBankFailure,
    getCandidateBankSuccess,
    getCandidateBankFailure,
    editCandidateBankSuccess,
    editCandidateBankFailure,
    deleteCandidateBankSuccess,
    deleteCandidateBankFailure,
    getCandidateBankListSuccess,
    getCandidateBankListFailure,
    deleteCandidateBankListSuccess,
    deleteCandidateBankListFailure,
    getCandidateBankDropdownListSuccess,
    getCandidateBankDropdownListFailure,
    checkCandidateBankExistsSuccess,
    checkCandidateBankExistsFailure,
    putFinalOutcomeSuccess,
    putFinalOutcomeFailure,
    createCandidatesSuccess,
    createCandidatesFailure,
    getInterviewIncScreenSuccess,
    getInterviewIncScreenFailure,
    getCandidateGlobalFieldsSuccess,
    getCandidateGlobalFieldsFailure,
    getCandidateStatusFiltersSuccess,
    getCandidateStatusFiltersFailure,
    getInterviewDetailsByIdEmployeeSuccess,
    getInterviewDetailsByIdEmployeeFailure,
    reinviteUnattendedSuccess,
    reinviteUnattendedFailure,
} from '../action';
import INTERVIEW from '../../utils/api/interview';
import INCBOT from '../../utils/api/incbot';
import moment from 'moment-timezone';
const tenantId = getTenantId();

// Helper function to convert timezone name to {name, offset} format
const getTimezoneData = (timeZoneName) => {
    if (!timeZoneName) return null;
    try {
        const m = moment.tz(timeZoneName);
        const offset = m.utcOffset(); // Returns offset in minutes
        return {
            name: timeZoneName,
            offset: offset,
        };
    } catch (e) {
        console.error('Error converting timezone:', e);
        return null;
    }
};
function* fetchResumeScoreRequest(action) {
    try {
        const res = yield INTERVIEW.post('incbot/fetchResumeScore', action?.payload);
        if (res.status === 201 || res.status === 200) {
            yield put(fetchResumeScoreSuccess(res.data.result));
        }
    } catch (e) {
        yield put(fetchResumeScoreFailure());
    }
}
function* getDropdownQuestionRequest(action) {
    try {
        const res = yield INTERVIEW.get(`positions/questionDropdown/${action?.payload?.position}/incbot`);
        if (res.status === 201 || res.status === 200) {
            yield put(getDropdownQuestionSuccess(res.data.result));
            if (action?.payload?.callback) yield call(action.payload.callback, res.data.result);
        }
    } catch (e) {
        yield put(getDropdownQuestionFailure());
        yield toast.error(<Toast msg={e?.response?.data?.message} />, {
            autoClose: 5000,
            toastId: e?.response?.data?.message,
        });
    }
}
function* getDropdownPositionRequest(action) {
    try {
        const res = yield INTERVIEW.get(`positions/dropdown`);
        if (res.status === 201 || res.status === 200) {
            yield put(getDropdownPositionSuccess(res.data.result));
        }
    } catch (e) {
        yield put(getDropdownPositionFailure());
    }
}
function* getCandidateRequest(action) {
    try {
        const status =
            action.payload?.activeTab === 'Network Disconnected'
                ? 'Network Disconnected'
                : action.payload?.activeTab === 'Completed Interviews'
                  ? 'Recommended,Cautiously Recommended,Not Recommended'
                  : '';
        const isSearch = action.payload?.search ? `&search=${encodeURIComponent(action.payload?.search)}` : '';
        const isPageAndPageSize =
            action.payload?.page && action.payload?.pageSize
                ? `?page=${action.payload.page}&pageSize=${action.payload?.pageSize}`
                : '';
        const isSort = action.payload.filter
            ? action.payload.filter.sort
                ? `&sort=${action.payload.filter.sort}`
                : action.payload.sort
                  ? `&sort=${action.payload.sort}`
                  : ''
            : action.payload.sort
              ? `&sort=${action.payload.sort}`
              : '';
        const isFilter = action.payload.filter
            ? (action.payload.filter.from
                  ? action.payload.filter.to
                      ? `&from=${action.payload.filter.from}T00:00:00&to=${action.payload.filter.to}T23:59:59`
                      : `&from=${action.payload.filter.from}T00:00:00&to=3000-12-31T23:59:59`
                  : action.payload.filter.to
                    ? `&from=2000-01-01T00:00:00&to=${action.payload.filter.to}T23:59:59`
                    : '') +
              (action.payload.filter.qFrom && action.payload.filter.qTo
                  ? `&qFrom=${action.payload.filter.qFrom}&qTo=${action.payload.filter.qTo}`
                  : '') +
              (action.payload.filter.status
                  ? `&status=${action.payload.filter.status}`
                  : status
                    ? `&status=${status}`
                    : '') +
              (action.payload.filter.createdBy ? `&createdBy=${action.payload.filter.createdBy}` : '') +
              (action.payload.filter.candidateBankId
                  ? `&candidateBankId=${action.payload.filter.candidateBankId}`
                  : '') +
              (action.payload.filter.positionId ? `&positionId=${action.payload.filter.positionId}` : '') +
              (action.payload.filter.suspiciousActivity
                  ? `&suspiciousActivity=${action.payload.filter.suspiciousActivity}`
                  : '') +
              (action.payload.filter.globalFieldFilters
                  ? Object.entries(action.payload.filter.globalFieldFilters)
                        .filter(([, v]) => v)
                        .map(([k, v]) => `&gf_${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
                        .join('')
                  : '')
            : '';

        const res = yield INTERVIEW.get(`incbot/getCandidates${isPageAndPageSize}${isSearch}${isFilter}${isSort}`);
        if (res.status === 201 || res.status === 200) {
            if (action?.payload?.page === 'all') {
                yield put(getCandidateFailure());
                yield call(action.payload.callback, res.data.result);
            } else {
                yield put(getCandidateSuccess(res.data.result));
            }
        } else {
            yield put(getCandidateFailure());
        }
    } catch (e) {
        yield put(getCandidateFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}
function* postCandidateRequest(action) {
    try {
        const formData = new FormData();
        const { position, question, candidate, expiredAt, startAt, linkExpiryType, customFields, timeZone } =
            action.payload.form;
        const { linkExpiresIn, resumeScore, checkResumeScore, interviewId, replicateId, resume } = action.payload.form;
        formData.append('position', position);
        formData.append('question', question);
        formData.append('expiredAt', expiredAt);
        formData.append('startAt', startAt);
        formData.append('linkExpiryType', linkExpiryType);
        formData.append('linkExpiresIn', linkExpiresIn);

        // Add timezone if available (for time-wise expiry)
        if (timeZone && linkExpiryType === 'time-wise') {
            const timezoneData = getTimezoneData(timeZone);
            if (timezoneData) {
                formData.append('timezone', JSON.stringify(timezoneData));
            }
        }
        formData.append('resumeScore', resumeScore || 0);
        formData.append('checkResumeScore', checkResumeScore || false);
        formData.append('cecKey', true);
        if (interviewId) formData.append('interviewId', interviewId);
        if (replicateId) formData.append('replicateId', replicateId);
        if (resume) formData.append('resume', resume);

        // Process custom fields and extract file attachments
        const processedCustomFields = (customFields || []).map((field) => {
            if (field.fieldType === 'file' && field.file) {
                // Add file(s) with the same key
                formData.append('customFieldFiles', field.file);

                // Return field with file name instead of file object
                return {
                    ...field,
                    values: field.file.name,
                    file: null,
                };
            }
            return field;
        });

        // Include customFields within the candidate object
        const candidateWithCustomFields = {
            ...candidate,
            customFields: processedCustomFields,
        };
        formData.append('candidate', JSON.stringify(candidateWithCustomFields));

        // Process global fields and extract file attachments
        if (action.payload.form.globalFields && Object.keys(action.payload.form.globalFields).length > 0) {
            const globalFields = action.payload.form.globalFields;
            const processedGlobalFields = {};

            Object.keys(globalFields).forEach((fieldId) => {
                const fieldValue = globalFields[fieldId];
                if (fieldValue && fieldValue instanceof File) {
                    formData.append('customFieldFiles', fieldValue);
                    processedGlobalFields[fieldId] = fieldValue.name;
                } else {
                    processedGlobalFields[fieldId] = fieldValue;
                }
            });

            formData.append('globalFields', JSON.stringify(processedGlobalFields));
        }
        const res = yield INTERVIEW.post(`incbot/createAndUpdateCandidate`, formData, {
            headers: {
                'content-type': 'multipart/form-data',
            },
        });
        if (res.status === 201) {
            yield put(createOrUpdateCandidateSuccess(res.data.result));
            yield call(action.payload.callback);
        }
    } catch (e) {
        yield put(createOrUpdateCandidateFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

function* cancelInterviewRequest(action) {
    try {
        const res = yield INTERVIEW.put(`incbot/cancelInterview/${action.payload.interviewId}`, {
            reason: action.payload.reason,
        });
        if (res.status === 201 || res.status === 200) {
            yield put(cancelInterviewSuccess(res.data.result));
            toast.success(<Toast msg={'Interview Canceled Successfully'} />, {
                autoClose: 5000,
                toastId: 'Interview Canceled Successfully',
            });
            yield call(action.payload.callback);
        }
    } catch (e) {
        yield put(cancelInterviewFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}
function* postBulkCandidateRequest(action) {
    const {
        position,
        question,
        bankId,
        expiredAt,
        linkExpiresIn,
        callback,
        linkExpiryType,
        startAt,
        customFields,
        timeZone,
    } = action?.payload;
    const url = `incbot/candidateBank/postBulkCandidates`;
    try {
        const payload = {
            bankId,
            positionId: position,
            questionId: question,
            expiredAt,
            linkExpiresIn,
            linkExpiryType,
            startAt,
            customFields: customFields && customFields.length > 0 ? customFields : undefined,
            globalFields: action.payload.globalFields || undefined,
        };

        // Add timezone if available
        if (timeZone) {
            const timezoneData = getTimezoneData(timeZone);
            if (timezoneData) {
                payload.timezone = timezoneData;
            }
        }

        const res = yield INTERVIEW.post(url, payload);
        if (res.status === 200 || res.status === 201) {
            yield put(editCandidateBankSuccess());
            yield call(callback);
            toast.success(<Toast msg={`Candidate bank submitted successfully`} />, {
                autoClose: 5000,
                toastId: `Candidate bank submitted successfully`,
            });
        }
    } catch (e) {
        console.log(e);
        yield put(editCandidateBankFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

function* resendEmailRequest(action) {
    try {
        const res = yield INTERVIEW.post(`incbot/reInviteCandidate/${action?.payload?.interviewId}`);
        if (res.status === 201 || res.status === 200) {
            yield put(resendEmailSuccess(res.data.result));
            toast.success(<Toast msg={'Email sent Successfully.'} />, {
                autoClose: 5000,
                toastId: 'Email sent Successfully.',
            });
            yield call(action?.payload?.callback);
        }
    } catch (e) {
        yield put(resendEmailFailure());
    }
}

function* compareJDCVRequest(action) {
    let formData = new FormData();
    const jdcvErrorMsg = 'File format is not correct';
    formData.append('jd', action.payload.jd);
    formData.append('cv', action.payload.cv);
    if (action.payload.incbotInterviewId) {
        formData.append('incbotInterviewId', action.payload.incbotInterviewId);
    }
    try {
        const res = yield INTERVIEW.post(`incbot/compareJDToCV`, formData, {
            headers: {
                'content-type': 'multipart/form-data',
                ...(tenantId && { 'x-tenant-id': tenantId }),
            },
        });
        if (res.status === 201 || res.status === 200) {
            yield put(compareJDCVSuccess(res.data));
            if (action.payload.callback) {
                yield call(action.payload.callback);
            }
            const percentage = Number(res.data.matchingPercentage);
            if (percentage <= 0) {
                toast.error(<Toast msg={jdcvErrorMsg} />, {
                    autoClose: 5000,
                    toastId: jdcvErrorMsg,
                });
            }
        }
    } catch (e) {
        yield put(compareJDCVFailure());
        if (action.payload.failure) {
            yield call(action.payload.failure);
        }
        toast.error(<Toast msg={jdcvErrorMsg} />, {
            autoClose: 5000,
            toastId: jdcvErrorMsg,
        });
    }
}

function* postResumeInterviewRequest(action) {
    try {
        const res = yield INTERVIEW.post('incbot/resumeInterview', {
            interviewId: action.payload.resumeId,
        });
        if (res.status === 200 || res.status === 201) {
            yield put(resumeInterviewSuccess());
            toast.success(<Toast msg={'Candidate invited to resume the interview successfully.'} />, {
                autoClose: 5000,
                toastId: 'Candidate invited to resume the interview successfully.',
            });
            yield call(action.payload.callback);
        } else throw new Error('');
    } catch (e) {
        yield put(resumeInterviewFailure());
        toast.error(<Toast msg={'Unable to send an invite to resume the interview. Please contact InCruiter'} />, {
            autoClose: 5000,
            toastId: 'Unable to send an invite to resume the interview. Please contact InCruiter',
        });
    }
}

function* manualInviteRequest(action) {
    try {
        const res = yield INTERVIEW.patch(`incbot/manualInvite/${action.payload.id}`);
        if (res.status === 201) {
            yield put(manualInviteSuccess());
            yield call(action?.payload?.callback);
        }
    } catch (e) {
        yield put(manualInviteFailure());
    }
}

function* manualCallEndRequest(action) {
    try {
        const res = yield INCBOT.post(`callEnd/${action.payload?.roomId}`, {
            endCallStatus: 'Dashboard Call End',
        });
        if (res.status === 200 || res.status === 201) {
            yield put(manualCallEndSuccess());
            yield call(action.payload?.callback);
            toast.success(<Toast msg={'Feedback generation under progress.'} />, {
                autoClose: 5000,
                toastId: 'Feedback generation under progress.',
            });
        } else {
            yield put(manualInviteFailure());
            toast.error(<Toast msg={'Unable to generate feedback report at the moment.'} />, {
                autoClose: 5000,
                toastId: 'Unable to generate feedback report at the moment.',
            });
        }
    } catch {
        yield put(manualInviteFailure());
        toast.error(<Toast msg={'Unable to generate feedback report at the moment.'} />, {
            autoClose: 5000,
            toastId: 'Unable to generate feedback report at the moment.',
        });
    }
}

function* addCandidateBankRequest(action) {
    try {
        const { formData, callback, failureCallback, summaryCallback } = action?.payload;
        const res = yield INTERVIEW.post(`incbot/createCandidateBank`, formData, {
            headers: {
                'content-type': 'multipart/form-data',
                ...(tenantId && { 'x-tenant-id': tenantId }),
            },
        });
        // INC-909: confirm=0 only validates the file - show the duplicate popup, nothing was saved.
        if (res?.data?.result?.status && res?.data?.result?.saved === false) {
            yield put(addCandidateBankSuccess());
            if (summaryCallback) yield call(summaryCallback, res?.data?.result?.summary);
        } else if (res?.data?.result?.status && res.status === 201) {
            yield put(addCandidateBankSuccess());
            yield call(callback);
            toast.success(<Toast msg={'Candidate bank uploaded successfully.'} />, {
                autoClose: 5000,
                toastId: 'Candidate bank uploaded successfully.',
            });
        } else {
            yield put(addCandidateBankFailure());
            yield call(failureCallback);
            toast.error(<Toast msg={res?.data?.result?.error} />, {
                autoClose: 5000,
                toastId: res?.data?.result?.error,
            });
        }
    } catch (e) {
        console.log(e);
        yield put(addCandidateBankFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

function* getCandidateBankRequest(action) {
    try {
        const isSearch = action.payload?.search ? `&search=${encodeURIComponent(action.payload.search)}` : '';

        const isPageAndPageSize =
            action.payload?.page && action.payload?.pageSize
                ? `?page=${action.payload.page}&pageSize=${action.payload.pageSize}`
                : '';

        const isSort = action.payload?.sort ? `&sort=${action.payload.sort}` : '';

        const res = yield INTERVIEW.get(`incbot/getCandidateBank${isPageAndPageSize}${isSearch}${isSort}`);

        if (res.status === 200 || res.status === 201) {
            yield put(getCandidateBankSuccess(res?.data?.result));
        }
    } catch (e) {
        console.log(e);
        yield put(getCandidateBankFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

export function* editCandidateBankRequest(action) {
    const { name, candidateBankID, callback } = action?.payload;
    try {
        const res = yield INTERVIEW.post(`incbot/updateCandidateBank/${candidateBankID}`, {
            name,
        });
        if (res?.data?.result?.status && res.status === 201) {
            yield put(editCandidateBankSuccess());
            yield call(callback);
            toast.success(<Toast msg={'Candidate bank updated successfully.'} />, {
                autoClose: 5000,
                toastId: 'Candidate bank updated successfully.',
            });
        } else {
            yield put(editCandidateBankFailure());
            toastMessage('error', res?.data?.result?.error);
        }
    } catch (e) {
        console.log(e);
        yield put(editCandidateBankFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

export function* deleteCandidateBankRequest(action) {
    const { candidateBankID, callback } = action?.payload;
    try {
        const res = yield INTERVIEW.delete(`incbot/candidateBank/${candidateBankID}`);
        if (res.status === 204) {
            yield put(deleteCandidateBankSuccess());
            yield call(callback);
            toast.success(<Toast msg={'Candidate bank deleted successfully.'} />, {
                autoClose: 5000,
                toastId: 'Candidate bank deleted successfully.',
            });
        }
    } catch (e) {
        console.log(e);
        yield put(deleteCandidateBankFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

function* getCandidateBankListRequest(action) {
    try {
        const { candidateBankID, search, page, pageSize, sort, callback } = action?.payload;
        const isSearch = search ? `&search=${encodeURIComponent(search)}` : '';
        const isPageAndPageSize = page && pageSize ? `?page=${page}&pageSize=${pageSize}` : '';
        const isSort = sort ? `&sort=${sort}` : '';
        const res = yield INTERVIEW.get(
            `incbot/candidateBankCandidateList/${candidateBankID}${isPageAndPageSize}${isSearch}${isSort}`
        );
        if (res.status === 200 || res.status === 201) {
            if (callback) {
                // Export flow: hand the result to the caller and leave the paginated list in the store untouched
                yield put(getCandidateBankListFailure());
                yield call(callback, res?.data?.result);
            } else {
                yield put(getCandidateBankListSuccess(res?.data?.result));
            }
        }
    } catch (e) {
        console.log(e);
        yield put(getCandidateBankListFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

function* deleteCandidateBankListRequest(action) {
    try {
        const { deleteID, candidateBankID, callback } = action?.payload;

        const res = yield INTERVIEW.delete(`incbot/candidateBankCandidate/${candidateBankID}/${deleteID}`);

        if (res.status === 204) {
            yield put(deleteCandidateBankListSuccess());
            yield call(callback);
            toast.success(<Toast msg={'Candidate deleted successfully.'} />, {
                autoClose: 5000,
                toastId: 'Candidate deleted successfully.',
            });
        }
    } catch (e) {
        console.log(e);
        yield put(deleteCandidateBankListFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

function* addEditCandidateBankListRequest(action) {
    const { candidateBankId, candidateId, name, email, phone, resume, customFields, callback } = action?.payload;
    const formData = new FormData();
    if (candidateId) formData.append('candidateId', candidateId);
    if (name) formData.append('name', name);
    if (email) formData.append('email', email);
    if (phone) formData.append('phone', phone.replace('+', ''));
    if (typeof resume === 'object') formData.append('resume', resume);

    // Handle custom fields. File fields travel as separate customFieldFiles parts with only the file name
    // left in the JSON, the same convention createCandidates uses.
    if (customFields && customFields.length > 0) {
        const processedCustomFields = customFields.map((field) => {
            if (field.fieldType === 'file' && field.file) {
                formData.append('customFieldFiles', field.file);
                return { ...field, values: field.file.name, file: null };
            }
            return field;
        });
        formData.append('customFields', JSON.stringify(processedCustomFields));
    }

    const url = `incbot/updateCandidateBankCandidate/${candidateBankId}`;
    try {
        const res = yield INTERVIEW.post(url, formData, {
            headers: {
                'content-type': 'multipart/form-data',
                ...(tenantId && { 'x-tenant-id': tenantId }),
            },
        });
        if (res.status === 200 || res.status === 201) {
            yield put(editCandidateBankSuccess());
            yield call(callback);
            toast.success(<Toast msg={`Candidate data ${candidateId ? 'updated' : 'created'} successfully.`} />, {
                autoClose: 5000,
                toastId: `Candidate data ${candidateId ? 'updated' : 'created'} successfully.`,
            });
        }
    } catch (e) {
        console.log(e);
        yield put(editCandidateBankFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

function* getCandidateBankDropdownListRequest() {
    try {
        const res = yield INTERVIEW.get(`incbot/getCandidateBankDropDown`);
        if (res.status === 200 || res.status === 201) {
            yield put(getCandidateBankDropdownListSuccess(res?.data?.result));
        }
    } catch (e) {
        console.log(e);
        yield put(getCandidateBankDropdownListFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

function* checkCandidateBankExistsRequest(action) {
    const { data, callback } = action?.payload;
    try {
        const res = yield INTERVIEW.post(`incbot/candidateBank/checkDuplicate`, {
            bankId: data?.bankId,
            positionId: data?.position,
            questionId: data?.question,
        });
        if (res.status === 200 || res.status === 201) {
            yield put(checkCandidateBankExistsSuccess(res?.data?.result?.status));
            yield call(callback, res?.data?.result?.status);
        }
    } catch (e) {
        console.log(e);
        yield put(checkCandidateBankExistsFailure(false));
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

function* putFinalOutcomeRequest(action) {
    try {
        const res = yield INTERVIEW.put(`incbot/updateFinalOutCome/${action.payload.interviewId}`, {
            status: action.payload.status,
        });
        if (res.status === 201 || res.status === 200) {
            yield put(putFinalOutcomeSuccess());
            yield call(action.payload.callback);
        }
    } catch (e) {
        yield put(putFinalOutcomeFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

function* createCandidatesRequest(action) {
    try {
        const formData = new FormData();
        const { position, question, expiredAt, startAt, linkExpiryType, linkExpiresIn, customFields, timeZone } =
            action.payload.form;
        const { candidates, resume } = action.payload;
        formData.append('position', position);
        formData.append('question', question);
        formData.append('expiredAt', expiredAt);
        formData.append('startAt', startAt);
        formData.append('linkExpiryType', linkExpiryType);
        formData.append('linkExpiresIn', linkExpiresIn);

        // Add timezone if available
        if (timeZone) {
            const timezoneData = getTimezoneData(timeZone);
            if (timezoneData) {
                formData.append('timezone', JSON.stringify(timezoneData));
            }
        }
        // Process candidates and extract custom field files
        const processedCandidates = candidates.map((candidate) => {
            if (candidate.customFields && Array.isArray(candidate.customFields)) {
                const processedCustomFields = candidate.customFields.map((field) => {
                    if (field.fieldType === 'file' && field.file) {
                        // Add file to FormData with same key like resume
                        formData.append('customFieldFiles', field.file);

                        // Return field with file name instead of file object
                        return {
                            ...field,
                            values: field.file.name,
                            file: null, // Remove file object from JSON
                        };
                    }
                    return field;
                });

                return {
                    ...candidate,
                    customFields: processedCustomFields,
                };
            }
            return candidate;
        });

        formData.append('candidates', JSON.stringify(processedCandidates));
        if (Array.isArray(resume)) {
            resume.forEach((file) => {
                if (file) formData.append('resume', file);
            });
        }

        // Process global fields and extract file attachments
        if (action.payload.form.globalFields && Object.keys(action.payload.form.globalFields).length > 0) {
            const globalFields = action.payload.form.globalFields;
            const processedGlobalFields = {};

            Object.keys(globalFields).forEach((fieldId) => {
                const fieldValue = globalFields[fieldId];
                if (fieldValue && typeof fieldValue === 'object' && fieldValue.name && fieldValue instanceof File) {
                    // This is a file field, add it to FormData with same key like resume
                    formData.append('customFieldFiles', fieldValue);

                    // Store file name in processed global fields
                    processedGlobalFields[fieldId] = fieldValue.name;
                } else {
                    // Regular field value
                    processedGlobalFields[fieldId] = fieldValue;
                }
            });

            formData.append('globalFields', JSON.stringify(processedGlobalFields));
        }

        const res = yield INTERVIEW.post(`incbot/createCandidates`, formData, {
            headers: {
                'content-type': 'multipart/form-data',
            },
        });
        if (res.status === 201) {
            yield put(createCandidatesSuccess(res.data.result));
            yield call(action.payload.callback);
        }
    } catch (e) {
        yield call(action.payload.callbackFailure);
        yield put(createCandidatesFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

function* getInterviewIncScreenRequest(action) {
    try {
        const { interviewId, roomId } = action.payload;
        const res = yield INTERVIEW.get(`interviews/getInterviewScreen/${interviewId}/${roomId}`);
        if (res.status === 200 || res.status === 201) {
            yield put(getInterviewIncScreenSuccess(res.data.result));
        } else yield put(getInterviewIncScreenFailure());
    } catch (e) {
        yield put(getInterviewIncScreenFailure());
    }
}

function* getCandidateGlobalFieldsRequest(action) {
    try {
        const params = {
            page: action?.payload?.page || 1,
            pageSize: action?.payload?.pageSize || 100,
            ...(action?.payload?.fieldMode && { fieldMode: action.payload.fieldMode }),
            ...(action?.payload?.productFilterLabel && { productFilterLabel: action.payload.productFilterLabel }),
        };
        const res = yield INTERVIEW.get('interviews/CustomFields/list', { params });
        if (res.status === 200 || res.status === 201) {
            yield put(getCandidateGlobalFieldsSuccess(res.data.result));
        } else yield put(getCandidateGlobalFieldsFailure());
    } catch (e) {
        yield put(getCandidateGlobalFieldsFailure());
    }
}

function* getCandidateStatusFiltersRequest() {
    try {
        const res = yield INTERVIEW.get('incbot/candidateStatusFilters');
        if (res.status === 200 || res.status === 201) {
            yield put(getCandidateStatusFiltersSuccess(res?.data?.result ?? res?.data));
        } else yield put(getCandidateStatusFiltersFailure());
    } catch (e) {
        // Silent failure — the Status filter falls back to its built-in options.
        yield put(getCandidateStatusFiltersFailure());
    }
}

export function* watchGetCandidateStatusFiltersAPI() {
    yield takeEvery(GET_CANDIDATE_STATUS_FILTERS, getCandidateStatusFiltersRequest);
}

function* getInterviewDetailsByIdEmployeeRequest(action) {
    try {
        const { interviewId, callback, failure } = action.payload;
        const res = yield INTERVIEW.get(`incbot/getCandidates/${interviewId}`);
        if (res.status === 200 || res.status === 201) {
            yield put(getInterviewDetailsByIdEmployeeSuccess(res.data.result));
            if (callback) {
                yield call(callback, res.data.result);
            }
        } else {
            yield put(getInterviewDetailsByIdEmployeeFailure());
            if (failure) {
                yield call(failure);
            }
        }
    } catch (e) {
        yield put(getInterviewDetailsByIdEmployeeFailure());
        if (action.payload?.failure) {
            yield call(action.payload.failure);
        }
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

export function* watchCheckCandidateBankExistsAPI() {
    yield takeEvery(CHECK_CANDIDATE_BANK_EXISTS, checkCandidateBankExistsRequest);
}

export function* watchGetCandidateBankDropdownListAPI() {
    yield takeEvery(GET_CANDIDATE_BANK_DROPDOWN_LIST, getCandidateBankDropdownListRequest);
}

export function* watchAddEditCandidateBankListAPI() {
    yield takeEvery(ADD_EDIT_CANDIDATE_BANK_LIST, addEditCandidateBankListRequest);
}

export function* watchDeleteCandidateBankListAPI() {
    yield takeEvery(DELETE_CANDIDATE_BANK_LIST, deleteCandidateBankListRequest);
}

export function* watchGetCandidateBankListAPI() {
    yield takeEvery(GET_CANDIDATE_BANK_LIST, getCandidateBankListRequest);
}

export function* watchDeleteCandidateBankAPI() {
    yield takeEvery(DELETE_CANDIDATE_BANK, deleteCandidateBankRequest);
}

export function* watchEditCandidateBankAPI() {
    yield takeEvery(EDIT_CANDIDATE_BANK, editCandidateBankRequest);
}

export function* watchGetCandidateBankAPI() {
    yield takeEvery(GET_CANDIDATE_BANK, getCandidateBankRequest);
}

export function* watchAddCandidateBankAPI() {
    yield takeEvery(ADD_CANDIDATE_BANK, addCandidateBankRequest);
}

export function* watchResendEmailAPI() {
    yield takeEvery(RESEND_EMAIL, resendEmailRequest);
}

export function* watchGetCandidateAPI() {
    yield takeEvery(GET_CANDIDATE, getCandidateRequest);
}
export function* watchPostCandidateAPI() {
    yield takeEvery(POST_CANDIDATE, postCandidateRequest);
}
export function* watchCancelInterviewAPI() {
    yield takeEvery(CANCEL_INTERVIEW, cancelInterviewRequest);
}
export function* watchCompareJDCVAPI() {
    yield takeEvery(COMPARE_JD_CV, compareJDCVRequest);
}
export function* watchPostBulkCandidateAPI() {
    yield takeEvery(POST_BULK_CANDIDATE, postBulkCandidateRequest);
}
export function* watchGetDropdownQuestionAPI() {
    yield takeEvery(GET_DROPDOWN_QUESTION, getDropdownQuestionRequest);
}
export function* watchGetDropdownPositionAPI() {
    yield takeLeading(GET_DROPDOWN_POSITION, getDropdownPositionRequest);
}
export function* watchResumeInterviewAPI() {
    yield takeEvery(RESUME_INTERVIEW, postResumeInterviewRequest);
}
export function* watchManualInviteApi() {
    yield takeEvery(MANUAL_INVITE, manualInviteRequest);
}
export function* watchFetchResumeScoreApi() {
    yield takeEvery(FETCH_RESUME_SCORE, fetchResumeScoreRequest);
}
export function* watchManualCallEnd() {
    yield takeEvery(MANUAL_CALL_END, manualCallEndRequest);
}
export function* watchPutFinalOutcome() {
    yield takeEvery(PUT_FINAL_OUTCOME, putFinalOutcomeRequest);
}
export function* watchCreateCandidates() {
    yield takeEvery(CREATE_CANDIDATES, createCandidatesRequest);
}
export function* watchGetInterviewIncScreenAPI() {
    yield takeEvery(GET_INTERVIEW_INC_SCREEN, getInterviewIncScreenRequest);
}
export function* watchGetCandidateGlobalFieldsAPI() {
    yield takeEvery(GET_CANDIDATE_GLOBAL_FIELDS, getCandidateGlobalFieldsRequest);
}

export function* watchGetInterviewDetailsByIdEmployeeAPI() {
    yield takeEvery(GET_INTERVIEW_DETAILS_BY_ID_EMPLOYEE, getInterviewDetailsByIdEmployeeRequest);
}

function* reinviteUnattendedRequest(action) {
    try {
        const { interviewId, linkExpiryType, linkExpiresIn, startAt, expiredAt } = action.payload;
        const body = { linkExpiryType, startAt, expiredAt };
        if (linkExpiryType !== 'time-wise') {
            body.linkExpiresIn = linkExpiresIn;
        }
        const res = yield INTERVIEW.post(`incbot/reInviteCandidate/${interviewId}`, body);
        if (res.status === 201 || res.status === 200) {
            yield put(reinviteUnattendedSuccess());
            toast.success(<Toast msg="Invitation resent successfully." />, {
                autoClose: 5000,
                toastId: 'Invitation resent successfully.',
            });
            yield call(action.payload.callback);
        }
    } catch (e) {
        yield put(reinviteUnattendedFailure());
        toast.error(<Toast msg={e?.response?.data?.message || 'Failed to resend invitation. Please try again.'} />, {
            autoClose: 5000,
        });
        if (action.payload.failureCallback) yield call(action.payload.failureCallback);
    }
}

export function* watchReinviteUnattendedAPI() {
    yield takeEvery(REINVITE_UNATTENDED, reinviteUnattendedRequest);
}

export default function* rootSaga() {
    yield all([
        watchCompareJDCVAPI(),
        watchResendEmailAPI(),
        watchGetCandidateAPI(),
        watchPostCandidateAPI(),
        watchCancelInterviewAPI(),
        watchPostBulkCandidateAPI(),
        watchGetDropdownQuestionAPI(),
        watchGetDropdownPositionAPI(),
        watchResumeInterviewAPI(),
        watchManualInviteApi(),
        watchFetchResumeScoreApi(),
        watchManualCallEnd(),
        watchAddCandidateBankAPI(),
        watchGetCandidateBankAPI(),
        watchEditCandidateBankAPI(),
        watchDeleteCandidateBankAPI(),
        watchGetCandidateBankListAPI(),
        watchDeleteCandidateBankListAPI(),
        watchAddEditCandidateBankListAPI(),
        watchGetCandidateBankDropdownListAPI(),
        watchCheckCandidateBankExistsAPI(),
        watchPutFinalOutcome(),
        watchCreateCandidates(),
        watchGetInterviewIncScreenAPI(),
        watchGetCandidateGlobalFieldsAPI(),
        watchGetCandidateStatusFiltersAPI(),
        watchGetInterviewDetailsByIdEmployeeAPI(),
        watchReinviteUnattendedAPI(),
    ]);
}
